var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortingDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85986 6.9691C4.88162 7.14315 5.41684 7.55655 5.56565 7.67831C5.86441 7.92276 6.14291 8.2443 6.37422 8.5417C6.7091 8.97226 7.07184 9.45966 7.49115 9.7991C7.71799 9.98273 8.04415 10.318 8.19008 10.5734C8.26016 10.696 8.45223 10.81 8.55326 10.9092C8.86793 11.218 9.3117 11.6823 9.69759 11.9028C9.93736 12.0398 9.97555 12.4132 10.2526 12.0569C10.3806 11.8924 10.5645 11.5748 10.746 11.4711C10.8476 11.413 11.1239 10.9807 11.1982 10.8544C11.3959 10.5183 11.745 10.0956 12.0616 9.86762C12.6077 9.47449 12.9847 8.84167 13.5246 8.42179C13.913 8.11968 14.2573 7.73876 14.6175 7.4145C14.9528 7.11274 15.39 6.81521 15.5906 6.41406",
    stroke: "#95959B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingDownArrow);
export default __webpack_public_path__ + "static/media/sorting-down-arrow.78e45f7769c4492538ee9e2c764e9669.svg";
export { ForwardRef as ReactComponent };